module.exports = __webpack_public_path__ + "static/media/gallery3.44133cbc.jpg";